// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"d3250608","573":"64ce3c71"}[chunkId] + ".chunk.css";
};